module.exports = __webpack_public_path__ + "media/crypto/uma-8ad0c657.png";